import { useValidationRules } from "@/iti-core-react/hooks/validation-rule-required-editors";
import DxTextArea from "devextreme-react/text-area";
import DxValidator from "devextreme-react/validator";
import {
	InitializedEvent,
	ValueChangedEvent,
} from "devextreme/ui/text_area_types";
import { useEffect, useState } from "react";
import { ItiString } from "../../utils/iti-string";

interface ItiTextAreaProps {
	name?: string;
	label?: string;
	textBoxAttributes?: { [key: string]: any };
	labelClass?: string;
	width?: number;
	height?: number;
	tabIndex?: number;
	stylingMode?: "outlined" | "underlined" | "filled";
	placeholder?: string;
	readOnly?: boolean;
	disabled?: boolean;
	visible?: boolean;
	value?: string;
	className?: string;
	validationRules?: any;
	validationMessageMode?: "always" | "auto";
	maxLength?: number;
	showCharacterCounter?: boolean;
	onValueChanged?: (e: ValueChangedEvent) => void;
	saveTextAreaInstance?: (e: InitializedEvent) => void;
}

export default function ItiTextAreaComponent({
	name,
	label,
	textBoxAttributes = { class: "field-md field-area" },
	labelClass = "dx-field-item-label-text",
	placeholder,
	readOnly = false,
	disabled = false,
	visible = true,
	width,
	height = 100,
	stylingMode = "outlined",
	tabIndex,
	value,
	className,
	validationRules,
	validationMessageMode = "always",
	onValueChanged,
	saveTextAreaInstance,
	maxLength,
	showCharacterCounter = false,
}: Readonly<ItiTextAreaProps>) {
	const { isRequired } = useValidationRules(validationRules);
	const [currentLength, setCurrentLength] = useState(0);

	useEffect(() => {
		if (showCharacterCounter && value !== undefined) {
			setCurrentLength(value.length);
		}
	}, [value, showCharacterCounter]);

	return (
		<>
			{label && !ItiString.isNullOrWhiteSpace(label) && (
				<div
					className={`d-flex align-items-center ${showCharacterCounter ? "label-with-counter" : ""}`}
				>
					<span className={labelClass}>{label + (isRequired ? "*" : "")}</span>
					{showCharacterCounter && maxLength && (
						<span className="counter-text">
							{currentLength}/{maxLength}
						</span>
					)}
				</div>
			)}

			<DxTextArea
				name={name}
				elementAttr={textBoxAttributes}
				placeholder={placeholder}
				readOnly={readOnly}
				disabled={disabled}
				visible={visible}
				height={height}
				className={className}
				stylingMode={stylingMode}
				width={width}
				tab-index={tabIndex}
				value={value}
				validationMessageMode={validationMessageMode}
				onValueChanged={(e: ValueChangedEvent) => {
					e.event?.preventDefault();
					// Actualizar el valor del contador de caracteres si está habilitado
					if (showCharacterCounter && e.value !== undefined) {
						setCurrentLength(e.value.length);
					}
					if (onValueChanged) {
						onValueChanged(e);
					}
				}}
				onInitialized={saveTextAreaInstance}
			>
				<DxValidator validationRules={validationRules} />
			</DxTextArea>
		</>
	);
}
